module.exports = __webpack_public_path__ + "img/earth.ecce2ba3.svg";